export const noopStopPropagation = (event) => event?.stopPropagation()

export const withStopPropagation = (cb) => (event) => {
    event?.stopPropagation();
    cb?.();
}
